import { atom } from 'recoil';
import { UserType } from '../types/UserType';

export const UserState = atom<UserType>({
  key: 'UserState',
  default: {
    current: null,
  },
});
